import * as React from "react";

export type ClampedContentProps = {
  children: React.ReactNode;
  maxHeight?: number;
};

export const ClampedContent: React.FC<ClampedContentProps> = ({
  children,
  maxHeight = 280,
}) => {
  const [expanded, setExpanded] = React.useState(false);
  const [needsClamp, setNeedsClamp] = React.useState(false);
  const contentRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    setExpanded(false);
  }, [children]);

  React.useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    setNeedsClamp(el.scrollHeight > maxHeight + 8);
  }, [children, maxHeight, expanded]);

  return (
    <div>
      <div
        ref={contentRef}
        className={`ai-analysis__clamped${expanded ? " ai-analysis__clamped--expanded" : ""}`}
        style={!expanded && needsClamp ? { maxHeight } : undefined}
      >
        {children}
        {!expanded && needsClamp ? <div className="ai-analysis__clamped-fade" aria-hidden /> : null}
      </div>
      {needsClamp && !expanded ? (
        <button
          type="button"
          className="ai-analysis__expand-link"
          onClick={() => setExpanded(true)}
        >
          Show full text ↓
        </button>
      ) : null}
    </div>
  );
};
